import { render, staticRenderFns } from "./BaseFormDialog.vue?vue&type=template&id=cd459238"
import script from "./BaseFormDialog.vue?vue&type=script&lang=js"
export * from "./BaseFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports